import Translation from './Translation';
import { getTranslateObject } from '../utils/commonUtils';
import { cloneDeep } from 'lodash';
export default class BaseModel {
    constructor(data = {}) {
        this.__data__ = cloneDeep(data) || {};
        this.translations = (data.translations || []).map(item => new Translation(item));
        this.setTranslate(data.languageCode, true);
    }

    setTranslate(languageCode = undefined, getDefaultOnEmpty = false) {
        this.translate = cloneDeep(getTranslateObject(this.translations, languageCode, getDefaultOnEmpty) || {});
        this.languageCode = getDefaultOnEmpty ? this.translate.languageCode : languageCode;
        this.languageName = this.translate.languageName;
    }

    getTranslate(languageCode = undefined) {
        return getTranslateObject(this.translations, languageCode);
    }

    export(exportData={}) {
        return {
            translations: this.translations.map(item => item.export()),
            languageCode: this.languageCode,
            languageName: this.languageName,
            ...exportData,
        }
    }
}